import { BiQueryResult } from '@euler/model/bi/result';
import { BiTableViz } from '@euler/model/bi/viz';
import { memo, useMemo } from 'react';
import { BiResultTable } from './BiResultTable';
import { BiVizMismatch } from './BiVizMismatch';
import { biTableOfTableViz } from './functions/biResultTable';
import { biVizLook } from './functions/biVizLook';

export const BiTableView = memo(
  ({
    viz,
    result,
    inlineCopy,
  }: {
    viz: BiTableViz;
    result: BiQueryResult;
    /** False where the container offers 复制数据 itself. */
    inlineCopy?: boolean;
  }) => {
    const table = useMemo(() => biTableOfTableViz(viz, result), [viz, result]);
    if (!table) return <BiVizMismatch />;
    return (
      <BiResultTable
        table={table}
        look={biVizLook(viz).table}
        inlineCopy={inlineCopy}
      />
    );
  },
);
